const normalizeTeacherNamePart = (value) => (value ?? "").toString().trim();

export const resolveTeacherDisplayName = (teacher) => {
    if(typeof teacher !== "object" || teacher === null) {
        return teacher;
    }

    const title = normalizeTeacherNamePart(teacher.titel ?? teacher.title);
    const firstName = normalizeTeacherNamePart(teacher.first_name);
    const lastName = normalizeTeacherNamePart(teacher.last_name);

    return [title, firstName, lastName].filter(Boolean).join(" ");
};
